module.exports = __webpack_public_path__ + "img/fubonLogo.be8fd40e.svg";